<template>
  <div id="app">
    <div class="wrap" v-if='!loading'>
      <div class="content">
        <h1>温馨提示</h1>
        <p> 欢迎使用医保电子凭证！【医保电子凭证】指与参保人员身份信息挂钩的，是参保信息电子化的唯一凭证，搭载于手机应用上进行显示，线下实体终端识读可获取相应的身份信息和参保信息。 </p>
        <p>在您使用医保电子凭证服务前，请认真阅读<span @click='toInfo(1)'>《用户授权协议》</span>、<span  @click='toInfo(2)'>《医保电子凭证用户协议》</span>和<span  @click='toInfo(3)'>《人脸识别认证服务须知》</span>全部条款，您同意并接受全部条款后再开始使用我们的服务。</p>
        <div class="btm">
          <p class="bottom" @click='agree'>
            <img  :src="agreeFlag ? png2 : png1" alt="">
            我已阅读<span @click='toInfo(1)'>《用户授权协议》</span>、<span  @click='toInfo(2)'>《医保电子凭证用户协议》</span>和<span  @click='toInfo(3)'>《人脸识别认证服务须知》</span>
          </p>
          <div class="clear">
            <div :class="agreeFlag ? 'btn' : 'opa btn'" @click="getTicket(faceFun1)">
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
var sign = null;
import { Toast, Indicator,MessageBox,Popup } from "mint-ui";
import pn1 from '../assets/111.png'
import pn2 from '../assets/222.png'
export default {
    name: "App",
    data() {
        return {
            png1: pn1,
            png2: pn2,
            loading: true,
            ticket: "",
            openId:'',
            agreeFlag: true,
            isFaceCheckMode: false
        };
    },
  /*
   逻辑有些复杂，梳理清楚后在此记录一下
  1 有code：code附给ticket，后续没任何逻辑，看起来没啥用
  2 无code：
      2.1 有SdkOpenId：
      触发源头来自卡包的医保或者爱山东我的里边的医保，点击医保，卡包判断没有授权，则请求到此h5页面带着faceCheck参数，后端接口获取到授权页面后，重定向到我们的h5, 此时h5只需要调起接口，来获取医保详情页面。所有前端是如下的逻辑：
          2.1.1 有faceCheck参数，表示需要人脸获取图片，传给med-card/card-h5，接口会重定向
          2.1.2 调用med-card/card-h5（表示来自我们的卡包，并且从医保授权页面成功后重定向回来的，此时不用管是否有appid？）
      2.2 没有SdkOpenId，获取ticket（从爱山东首页单独的医保直接进入的h5页面）
          2.2.1 没有appid则调用med-card/verification
              状态返回通过，则人脸，人脸后获取ticket（需要再次获取ticket时因为ticket用一次后就失效了），之后调用med-card/card-h5
              状态返回没通过，则展示协议页面，下一步调用人脸，人脸后获取ticket，获取人脸后的图片，之后调用med-card/card-h5
          2.2.2 有appid：调用med-card/card-h5（重定向回来的？）

  */
    created() {
        let code = location.href.split("code=")[1];
        let appid = location.href.split("appId=")[1]; // 表示从医保平台重定向回来的情况
        let faceCheck = location.href.split("faceCheck=")[1] // 表示我们的接口发现还没有授权，需要带着人脸图片去授权，所以需要前端去人脸后获取图片，传给接口
        this.isFaceCheckMode = faceCheck ? true : false;
        if (code) {
            this.ticket = code; // TODO 有code的逻辑，看起来啥也没做呢，没看懂code的逻辑是要干什么, 暂时先保留
            return
        }
        // if (appid) {
        //    this.loading = true; // 默认本来就是true，此时不需要设置了
        // }
        // if (this.isFaceCheckMode == 1) {
        //     this.loading = true; // 默认本来就是true，此时不需要设置了
        // }
        // 有sdkopenid表示从我们自己的卡包中发起的，没有表示此页面单独被引用的情况

        if (isAndroid && typeof(SdkOpenId) != "undefined") {
            this.openId = SdkOpenId.getOpenId();
        } else if (isiOS && typeof(window.SdkOpenId)!="undefined") {
            this.openId = window.SdkOpenId.getOpenId();
        }
        if (!this.openId) {//爱山东里边单独医保模块的逻辑
            this.getTicket(this.gotoInter);
        } else {
            if (this.isFaceCheckMode) {
                this.faceFun1()
            } else {
                this.getCode();
            }
        }
    },
  methods: {
    agree(){
      this.agreeFlag =! this.agreeFlag;
    },
    toInfo (e){
      sessionStorage.index=e;
      this.$router.push({
        name:'info'
      })
    },
    closeFun() {
      lightAppJssdk.navigation.close({
          success: function (data) { },
          fail: function (data) { }
      });
    },
    faceFun() {
      let that = this;
      lightAppJssdk.user.humanface({
        success: function(data) {
          if (data.result == "true") {
            that.loading = true;
            Indicator.open();
            sessionStorage.index=1;
            that.getTicket(that.getCode);
          }
        },
        fail: function(data) {
        }
      });
    },
    faceFun1() {
      let that = this;
      lightAppJssdk.user.humanface({
        success: function(data) {
            if (data.result == "true") {
                 if (typeof data.data == 'string') {
                     // 因为返回来的格式有问题，用JSON.parse会报错，主要用字符串截取来做了
                     // let jsonData = JSON.parse(data.data)
                     // let certifyIdResult = JSON.parse(jsonData.result)
                     let start = data.data.indexOf('result={')
                     let end = data.data.indexOf(', ex={')
                     let certifyIdResult = JSON.parse(data.data.substring(start+7, end))
                     let certifyId = certifyIdResult.certifyId
                     that.getFaceImage(certifyId)
                 } else {
                     let certifyId = data.data.result && data.data.result.certifyId;
                     that.getFaceImage(certifyId)
                 }

            }
        },
        fail: function(data) {
            alert('humanface--data.data--fail---' + JSON.stringify(data))
        }
      });
    },
    getFaceImage(certifyId) {
        let that = this
        lightAppJssdk.user.getFacePicture({
    		certifyId: certifyId,    //支付宝扫脸认证成功后的返回值
    		authKey: "34DDCE1890DBFC6DEC0011C669076723D3F145B06D6958314716D1949A1C2E31FE8AB53BF0E8A445E6463561CA2B1A14",    //后台申请生成的值
    		success: function(res) {
                if (res.result == 'true') {
                    if (typeof res.data == 'string') {
                        let imgResult = JSON.parse(res.data)
                        let material_info = JSON.parse(imgResult.material_info)
                        let picFront = material_info.facial_picture_front
                        that.pushImage(picFront.FEATURE_FACE)
                    } else {
                        let material_info = JSON.parse(res.data.material_info);
                        let picFront = material_info.facial_picture_front
                        that.pushImage(picFront.FEATURE_FACE)
                    }
                }
    		},
    		fail: function(data) {
                alert('getFacePicture---data-fail---'+ JSON.stringify(data));
    		}
    	});
    },
    pushImage(imageBase64) {
        let that = this;
        Indicator.open();
        this.$axios({
            method: "POST",
            url: "/certSdk/med-card/card-h5",
            timeout: 35000,
            headers: {
                ticket: that.ticket,
                openId: that.openId
            },
            data:{
              certId: 314,
              userFaceImg: imageBase64
            }
        }).then(function(res) {
            Indicator.close();
            if (res.data.code == 0) {
                location.href = res.data.data;
            } else {
                Toast({
                    message: res.data.message,
                    position: "bottom",
                    duration: 5000
                });
            }
        }).catch(function(error) {
            Indicator.close();
            Toast({
                message: "服务器出错",
                position: "bottom",
                duration: 5000
            });
        });
    },
    gotoInter() {
        let appid = location.href.split("appId=")[1];// 表示从医保平台授权页面回调回来的参数
        if (appid) {
           this.getCode();
        } else {
           this.getStatus();
        }
    },
    getTicket(func) {
      let that = this;
      lightAppJssdk.user.getTicket({
        success: function(data) {
          if (data == "未登录") {
            that.login(func);
          } else {
            var jsonData = JSON.parse(data);
            if (jsonData.retcode == "000000") {
              jsonData = JSON.parse(jsonData.data);
              that.ticket = jsonData.ticket;
              if (func) {
                  func()
              }
            }
          }
        },
        fail: function(data) {
          Toast({
            message: data,
            position: "bottom",
            duration: 5000
          });
        }
      });
    },
    login(func) {
      let that = this
      lightAppJssdk.user.loginapp({
        success: function(data) {
          var dataObj = JSON.parse(data);
          if (dataObj.retcode == "000000") {
            //登录成功
            var dataValueObj = JSON.parse(dataObj.data);
            that.ticket = dataValueObj.ticket;
            if (func) {
                func()
            }
          } else {
            //失败
            Toast({
              message: "请稍后再试",
              position: "bottom",
              duration: 5000
            });
          }
        },
        fail: function(data) {

          //登录失败
          Toast({
            message: data,
            position: "bottom",
            duration: 5000
          });
        }
      });
    },
    getStatus() {
      let that = this;
      Indicator.open();
      this.$axios({
        method: "POST",
        url: "/certSdk/med-card/verification",
        timeout: 35000,
        headers: {
          ticket: that.ticket,
          openId: that.openId
        }
      }).then(function(res) {
          Indicator.close();
          if (res.data.code == 0) {
            if(res.data.data.authState==1){
              that.loading = true;
              that.faceFun();
            } else {
               that.loading = false;
            }
          } else {
            Toast({
              message: res.data.message,
              position: "bottom",
              duration: 5000
            });
          }
        })
        .catch(function(error) {
          Indicator.close();
          Toast({
            message: "服务器出错",
            position: "bottom",
            duration: 5000
          });
        });
    },
    getCode() {
      let that = this;
      Indicator.open();
      this.$axios({
        method: "POST",
        url: "/certSdk/med-card/card-h5",
        timeout: 35000,
        headers: {
          ticket: that.ticket,
          openId: that.openId
        },
        data:{
            certId:314
        }
      }).then(function(res) {
          Indicator.close();
          if (res.data.code == 0) {
            location.href = res.data.data;
          } else {
            Toast({
              message: res.data.message,
              position: "bottom",
              duration: 5000
            });
          }
        }).catch(function(error) {
          Indicator.close();
          Toast({
            message: "服务器出错",
            position: "bottom",
            duration: 5000
          });
        });
    }
  }
};
</script>

<style lang='scss' scoped="">
.wrap {
  background: #FFF;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .content {
    background: #fff;
    border-radius: 5px;
    font-size: 16px;
    color: #333;
    h1 {
      text-align: center;
      font-size: 18px;
      padding: 10px;
    }
    p {
      text-indent: 32px;
      padding: 0;
      margin: 0;
      padding: 0px 5%;
      span {
        color: #2E5CE8;
      }
    }
    .btm {
      position: absolute;
      bottom: 0;
      width: 100%;
      p {
        text-indent: 0;
        padding: 0 12px;
        font-size: 13px;
        line-height: 30px;
        img {
          margin-left: 5px;
          vertical-align: sub;
          width: 18px;
          padding:15px 0 15px 20px;
          margin-bottom: -15px;
        }
      }
    }
    div.clear {
      clear:both;
      overflow: hidden;
      border-top: 1px solid #ddd;
      margin-top: 20px;
      .btn {
        width: 90%;
        color: #fff;
        background: #375af9;
        text-align: center;
        border-radius: 40px;
        padding: 10px 0;
        margin: 10px auto;
      }
      .btn.opa {
        opacity: 0.5;
        pointer-events: none;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index1/components/ind.vue